import React from 'react'
import style from './nlu-basic-nlp-tabs.module.scss'
import { useDispatch, useSelector } from 'react-redux'
import { AppState } from '../../stateManager/store'
import { setBasicNLPTab } from '../../stateManager/store/uiState/actions'

export function NLUBasicNLPTabs() {
  const tab = useSelector((state: AppState) => state.uiState.selectedBasicNLPTab) ?? "schema"
  const dispatch = useDispatch()

  return (
    <div className={style.container}>
      <div className={style.line} />
      <div className={style.tabs}>
        <button className={style.tab} data-selected={tab === "schema"} onClick={() => {
          dispatch(setBasicNLPTab("schema"))
        }}>
          <p>Schema Layout</p>
          <div className={style.tabLine} />
        </button>
        <button className={style.tab} data-selected={tab === "data"} onClick={() => {
          dispatch(setBasicNLPTab("data"))
        }}>
          <p>Data Labelling</p>
          <div className={style.tabLine} />
        </button>
      </div>
    </div>
  )
}
